module.exports = __webpack_public_path__ + "static/media/jobs.80ecd1cf.svg";